import React from 'react';
import { ACTIVITIES } from '../data/constants';
import './ActivitySelector.css';

export default function ActivitySelector({ selectedActivities, onActivityChange }) {
  const toggleActivity = (activityId) => {
    if (selectedActivities.includes(activityId)) {
      onActivityChange(selectedActivities.filter(a => a !== activityId));
    } else {
      onActivityChange([...selectedActivities, activityId]);
    }
  };

  return (
    <div className="activity-selector">
      <h3>🎯 选择活动场景</h3>
      <div className="activity-grid">
        {ACTIVITIES.map(activity => (
          <button
            key={activity.id}
            className={`activity-btn ${selectedActivities.includes(activity.id) ? 'active' : ''}`}
            style={{
              '--activity-color': activity.color,
              borderColor: selectedActivities.includes(activity.id) ? activity.color : 'transparent',
              background: selectedActivities.includes(activity.id) ? `${activity.color}22` : 'var(--card-bg)'
            }}
            onClick={() => toggleActivity(activity.id)}
          >
            <span className="activity-emoji">{activity.emoji}</span>
            <span className="activity-label">{activity.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
